import { TRootState } from 'Redux/Reducers';

export const getAppUserEventIds = (state: TRootState, organisationId: string) =>
  state.appUser.assignedEventIdsByOrganisation[organisationId] || [];
